import { PictureOutlined } from '@ant-design/icons';
import { tran } from '@framework/engine/schema/translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '@framework/engine/schema/widgets/IWidgetType.ts';
import {
  WidgetCategory,
  WidgetMainType,
} from '@framework/engine/schema/widgets/Widget.ts';
import { type IImageWidget, WidgetImageType } from './IImageWidget.ts';
import { ImageWidgetComponent } from './ImageWidgetComponent.tsx';
import {
  ImageWidgetConfigComponent,
  ImageWidgetConfigSchema,
} from './ImageWidgetConfigComponent.tsx';
import { renderImageHtml } from './renderImageHtml.ts';

declare module '@framework/engine/schema/widgets/Widget.ts' {
  export enum WidgetType {
    Image = 'image',
  }
}

export const isImageWidgetType = (
  widget: IWidgetType<any>,
): widget is IWidgetType<IImageWidget> => {
  return widget.type === WidgetImageType;
};

export const ImageWidgetType: IWidgetType<IImageWidget> = {
  type: WidgetImageType,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Immagine',
  icon: <PictureOutlined />,
  supportedSectionTypes: ['DOCUMENT'],
  hasValue: false,
  formComponent: ImageWidgetComponent,
  configComponent: ImageWidgetConfigComponent,
  configValidator: ImageWidgetConfigSchema,
  previewComponent: ImageWidgetComponent,
  translationSchema: tran.widget({}),
  rules: [],
  renderHtml: renderImageHtml,
};
